<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="password-request">
    <div class="password-request-title">{{ $t('password_req') }}</div>
    <ul class="password-request-list">
      <li class="password-request-item">
        <div :class="passwordInput !== '' && !passReq1 ? 'icon-cross' : 'icon-check'" />
        {{ $t('pass_req1') }}
      </li>
      <li class="password-request-item">
        <div :class="passwordInput !== '' && !passReq2 ? 'icon-cross' : 'icon-check'" />
        {{ $t('pass_req2') }}
      </li>
      <li class="password-request-item">
        <div :class="passwordInput !== '' && !passReq3 ? 'icon-cross' : 'icon-check'" />
        {{ $t('pass_req3') }}
      </li>
      <li class="password-request-item">
        <div :class="passwordInput !== '' && !passReq4 ? 'icon-cross' : 'icon-check'" />
        {{ $t('pass_req4') }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    passwordInput: {
      type: String,
    },
  },
  data() {
    return {
      passReq1: false,
      passReq2: false,
      passReq3: false,
      passReq4: false,
    }
  },
  computed: {},
  watch: {
    passwordInput() {
      //8 characters
      if (this.passwordInput.length >= 8) this.passReq1 = true
      else this.passReq1 = false
      //uppercase
      let regex1 = /[A-Z]/
      if (regex1.test(this.passwordInput)) this.passReq2 = true
      else this.passReq2 = false
      //lowercase
      let regex2 = /[a-z]/
      if (regex2.test(this.passwordInput)) this.passReq3 = true
      else this.passReq3 = false
      //numbers
      let regex3 = /\d/
      if (regex3.test(this.passwordInput)) this.passReq4 = true
      else this.passReq4 = false
    },
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.password-request
  color: $grey-dark
  m-font-size(14, 18)

.password-request-title
  display: flex
  align-items: center
  min-height: vh(36px)

.password-request-item
  display: flex
  align-items: center
  padding: vh(6px) vw(8px) vh(6px) vw(12px)
  gap: vw(10px)
  list-style-type: none

  .icon-check
    m-icon("check", 20, $corporate_color)

  .icon-cross
    m-icon("close", 20, red)
</style>